module.exports = __webpack_public_path__ + "img/features-content-img-1-ua.7d18a181.png";